import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AdminLayout from '../layout/admin-layout.vue'
import AuthLayout from '../layout/auth-layout.vue'
import { clubUUID, currentClub, userUUID, loggedIn } from '@/shared/state';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'login' }
  },

  {
    name: 'super-admin',
    path: '/super-admin',
    component: AdminLayout,
    children: [

      {
        name: 'details-club',
        path: 'details-club/:clubUUID/:userUUID',
        component: () => import('../pages/clients/user/detailsClub.vue'),
      },
      {
        name: 'users',
        path: 'users/:userUUID',
        component: () => import('../pages/clients/user/users.vue'),
      },
      {
        name: 'details-user',
        path: 'details-user/:userUUID',
        component: () => import('../pages/clients/user/detailsUser.vue'),
      },
      {
        name: 'affected-user',
        path: 'affected-user',
        component: () => import('../pages/clients/user/affected_user.vue'),
      },
      {
        name: 'profile',
        path: 'profile/:userUUID',
        component: () => import('../pages/clients/user/profile.vue'),
      },
      {
        name: 'permissions-club-packs-id',
        path: 'permissions/club-packs-id',
        component: () => import('../pages/clients/packClub/index.vue'),
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!loggedIn.value) {
        return next({ name: 'login' })
      }
      next()



    },
  },

  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/login/Login.vue'),
        beforeEnter: (to, from, next) => {
          if (loggedIn.value) {
            console.log("loggedIn.value")
            console.log(loggedIn.value)
            return next({ name: 'list-clubs', params: { userUUID: userUUID.value } });
          }
          else {
            next()
          }
        }
      },

      {
        path: '',
        redirect: { name: 'login' }
      }
    ]
  },
  {
    path: '/error',
    component: AuthLayout,
    children: [
      {
        name: '404',
        path: '404',
        component: () => import('../pages/error/404.vue')
      },
      {
        path: '',
        redirect: { name: '404' }
      }
    ]
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


export default router
